import { render, staticRenderFns } from "./AppFavorite.vue?vue&type=template&id=88c012c0"
import script from "./AppFavorite.vue?vue&type=script&lang=js"
export * from "./AppFavorite.vue?vue&type=script&lang=js"
import style0 from "./AppFavorite.vue?vue&type=style&index=0&id=88c012c0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports